module.exports = "#secondary-page-cricket-promo{\n    z-index: 1;\n}"